import React, { useEffect, useState } from "react";
import "../Admin/AdminNav/adminnav.css";
import { roleConfigs, roleNavigation } from "./roleDashboardConfig";
import { getStoredUser, fetchArray } from "./useRoleDashboard";
import { Link, NavLink, useNavigate } from "react-router-dom";


export default function RoleNavigation({ role, profile }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const config = roleConfigs[role];
  const [resolvedUser, setResolvedUser] = useState(getStoredUser);
  useEffect(() => {
    if (profile !== undefined) return;
    const controller = new AbortController();
    const stored = getStoredUser();
    fetchArray("/api/users/getallUsers", controller.signal).then(users => {
      if (!controller.signal.aborted) setResolvedUser(users.find(user => user.username === stored.username) || stored);
    }).catch(() => {});
    return () => controller.abort();
  }, [profile]);
  const user = profile === undefined ? resolvedUser : profile;
  const name = user?.username || getStoredUser().username || config.title;
  const groups = roleNavigation(role, user);
  const companyLogos = {
    "98 Acres": "98-acres",
    "Ravana Pool Club": "ravana",
    "Flying Ravana": "flying-ravana",
    "Le Maas Tota": "villa",
    "Tea Factory": "tea-factory",
    "Walaa kulu": "walaa",
    "Halpe Tea": "halpe",
    "Ella Swing": "ella-swing",
    "Halpe Tea Tour": "halpe-tour",
    "Amber Swing Kandy": "amber-swing",
    "Ceylon Tea Supermarket": "ceylon-tea",
  };
  const companyName = (user?.companyName || "").trim().replace(/\s+/g, " ");
  const companyLogo = /^uhe exports?$/i.test(companyName)
    ? "halpe"
    : companyLogos[companyName];
  const companyLabel = companyLogo
    ? user.companyName
    : "Vella Group of Companies";
  return (
    <div className="vella-navigation">
      <header className="vl-topbar">
        <button
          className="vl-menu"
          aria-label="Toggle navigation"
          aria-expanded={open}
          aria-controls="vella-sidebar"
          onClick={() => setOpen(!open)}
        >
          <i className="fas fa-bars" />
        </button>
        <Link
          to={config.home}
          className={"vl-topbrand" + (companyLogo ? " vl-company-brand" : "")}
        >
          <img
            src={"/brands/" + (companyLogo || "vella") + ".jpeg"}
            alt={companyLabel}
          />
        </Link>
        <span className="vl-top-title">
          Asset Management <span>/ {config.title}</span>
        </span>
        <div className="vl-top-actions">
          <span className="vl-workspace">
            <span /> {config.scope === "group" ? "Group workspace" : user?.companyName || "Your workspace"}
          </span>
          <span className="vl-avatar">{name.slice(0, 2).toUpperCase()}</span>
        </div>
        <div
          className="vl-company-logos"
          role="region"
          aria-label="Vella group company logos"
          tabIndex={0}
        >
          {Object.entries(companyLogos).map(([company, logo]) => (
            <div className="vl-company-logo" key={logo} title={company}>
              <img src={"/brands/" + logo + ".jpeg"} alt={company} />
            </div>
          ))}
        </div>
      </header>
      {open && (
        <button
          className="vl-overlay"
          aria-label="Close navigation"
          onClick={() => setOpen(false)}
        />
      )}
      <aside
        id="vella-sidebar"
        className={"vl-sidebar" + (open ? " is-open" : "")}
      >
       
        
        <Link className="vl-sidebar-logo" to={config.home} onClick={() => setOpen(false)} aria-label="Vella dashboard">
          <img src="/brands/vella.jpeg" alt="Vella Group of Companies" width="112" height="24" />
        </Link>
        <nav aria-label={config.title + " navigation"}>
          {groups.map(([title, links]) => (
            <div className="vl-nav-group" key={title}>
              <p>{title}</p>
              {links.map(([to, label, icon]) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    "vl-nav-link" + (isActive ? " active" : "")
                  }
                >
                  <i className={"fas fa-" + icon} />
                  <span>{label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="vl-sidebar-bottom">
          <span className="vl-avatar">{name.slice(0, 2).toUpperCase()}</span>
          <div>
            <strong>{name}</strong>
            <small>{config.title}</small>
          </div>
          <button
            aria-label="Sign out"
            title="Sign out"
            onClick={() => {
              if (window.confirm("Sign out of Vella?")) {
                localStorage.removeItem("currentUser");
                localStorage.removeItem("token");
                navigate("/");
              }
            }}
          >
            <i className="fas fa-arrow-right-from-bracket" />
          </button>
        </div>
      </aside>
    </div>
  );
}
